<template>
  <div
    class="app-layout"
    :class="$route.meta.isCentered ? 'is-full-height' : ''"
  >
    <app-header
      :app-title="app.header.title"
      :is-sticky="false"
    >
      <tabs-nav
        slot="tabs-nav"
        :links="tabs"
      />
    </app-header>
    <main>
      <div class="container">
        <template v-if="$route.meta.isCentered">
          <div class="columns is-centered is-vcentered">
            <div class="column">
              <router-view />
            </div>
          </div>
        </template>
        <template v-else>
          <router-view />
        </template>
      </div>
    </main>
    <app-footer
      :links="app.footer.links"
    />
  </div>
</template>
<script>
import { AppHeader, AppFooter, TabsNav } from '@phila/phila-ui';

export default {
  name: "DefaultLayout",
  components: {
    AppHeader,
    AppFooter,
    TabsNav,
  },
  data () {
    return {
      tabs: [
        {
          text: 'Login',
          href: 'login',
          attrs: {
            id: "nav-login-btn",
          },
        },
        {
          text: 'Register',
          href: 'user-registration',
          attrs: {
            id: "nav-register-btn",
          },
        },
        {
          text: 'Search',
          href: 'search',
          attrs: {
            id: "nav-search-btn",
          },
        },
      ],
      isCentered: false,
    };
  },
  computed: {
    app () {
      return this.$store.state.app;
    },
  },
};
</script>